<template>
  <div class="container mb-4">
    <DataTable :value="actualOrderRows" :autoLayout="true">
      <template #header>
        <div class="p-d-flex p-jc-between">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style="color: black">
              {{invoiceName}}
            </span>
            <span class="p-inputgroup-addon">
              <i class="pi pi-calendar"></i>
            </span>
            <InputText v-model="invoiceDate" placeholder="Fakturadatum" />
            <span class="p-inputgroup-addon">
              <i class="pi pi-id-card"></i>
            </span>
            <InputText v-model="deliveryPeriod" placeholder="Leveransperiod" />
          </div>
          <div>
            <Button label="Generera faktura" icon="pi pi-refresh" @click="recalculateInvoice()" />
            <template v-if="archive">
              <Button label="Uppdatera faktura" icon="pi pi-plus" @click="updateInvoice()" />
            </template>
            <template v-else>
              <Button label="Spara faktura" icon="pi pi-plus" @click="saveInvoice()" />
            </template>
          </div>
        </div>
      </template>
      <Column field="article" header="Artikel" />
      <Column field="text" header="Text" />
      <Column field="amount" header="Antal" bodyStyle="text-align: right" />
      <ColumnGroup type="footer">
        <Row>
            <Column footer="Total:" :colspan="2" footerStyle="text-align: right" />
            <Column :footer="getTotal()" footerStyle="text-align: right" />
        </Row>
      </ColumnGroup>
    </DataTable>
    <InvoiceHydroSpec :specifications="actualSpecifications" />
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

import ProgressSpinner from 'primevue/progressspinner'
import DataTable from 'primevue/datatable'
import InputText from 'primevue/inputtext'
import Column from 'primevue/column'
import ColumnGroup from 'primevue/columngroup'
import Row from 'primevue/row'
import Button from 'primevue/button'

import InvoiceHydroSpec from './InvoiceHydroSpec'

import moment from 'moment'

export default {
  name: 'InvoiceHydroCreate',
  components: {
    ProgressSpinner,
    DataTable,
    InputText,
    Column,
    ColumnGroup,
    Row,
    Button,
    InvoiceHydroSpec
  },
  data () {
    return {
      invoiceName: '',
      actualOrderRows: [],
      actualSpecifications: [],
      deliveryPeriod: '',
      customerData: {}
    }
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    archive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['INVOICES', 'INVOICE_BY_ID', 'VISMA_ARTICLES', 'VISMA_ARTICLE_BY_ID', 'DRIVERS_BY_ID', 'DRIVERS', 'CUSTOMER_BY_ID'])
  },
  async mounted () {
    await this.$store.dispatch('GET_ACTIVE_INVOICES')
    await this.$store.dispatch('GET_DRIVERS')
    const currentInvoice = this.INVOICE_BY_ID(this.$props.id)
    if (currentInvoice) {
      this.invoiceName = currentInvoice.name
      if (currentInvoice.data) {
        this.actualOrderRows = [...currentInvoice.data.orderRows]
        this.actualSpecifications = [...currentInvoice.data.specification]
        this.deliveryPeriod = currentInvoice.data.date
        this.customerData = currentInvoice.data.customerData
      }
    }
  },
  methods: {
    getTotal () {
      return this.actualOrderRows.reduce((prev, curr) => curr.tag === 'Separator' ? prev : prev + parseFloat(curr.amount), 0).toFixed(2)
    },
    recalculateInvoice () {
      this.actualOrderRows = []
      this.actualOrderRows.push(...this.createVismaInvoice(this.$props.id))
      this.deliveryPeriod = moment().format('YYYY-MM-DD')
      this.customerData = this.CUSTOMER_BY_ID(this.INVOICE_BY_ID(this.$props.id).invoiceDatas[0].Order.data.kund)
    },
    saveInvoice () {
      this.$store.dispatch('SAVE_INVOICE_DATA', {
        id: this.$props.id,
        data: {
          orderRows: this.actualOrderRows,
          specification: this.actualSpecifications,
          date: this.deliveryPeriod,
          customerData: this.customerData
        }
      })
    },
    updateInvoice () {
      this.$store.dispatch('UPDATE_INVOICE_DATA', {
        id: this.$props.id,
        data: {
          customer: 1501,
          invoiceDate: this.invoiceDate,
          dmt: this.getDmtString(),
          dmtId: this.getDmtId(),
          period: this.deliveryPeriod,
          orderRows: this.actualOrderRows
        }
      })
      this.$router.go(-1)
    },
    filterOrders (id) {
      const orders = this.$store.getters.INVOICE_BY_ID(id).invoiceDatas.map(order => order.Order)
      return orders
    },
    sortActions (actions) {
      return actions.sort((a, b) => {
        return moment(a.startTime).valueOf() - moment(b.startTime).valueOf()
      })
    },
    calculateOrderRowHours (row) {
      let startTime = ''
      let rowStart = ''
      let rowEnd = ''
      let duration = moment.duration(0)
      this.sortActions(row.actions).forEach((value) => {
        switch (value.name) {
          case 'Startad':
            startTime = value.startTime
            rowStart = value.startTime
            break
          case 'Rast':
            duration.add(moment.duration(moment(value.startTime).diff(moment(startTime))))
            startTime = value.endTime
            break
          case 'Sparad':
            duration.add(moment.duration(moment(value.startTime).diff(moment(startTime))))
            rowEnd = value.startTime
            startTime = value.startTime
            break
        }
      })
      return {
        rowStart: moment(rowStart),
        rowEnd: moment(rowEnd),
        duration: this.roundDuration(duration)
      }
    },
    roundDuration (duration) {
      // const mStart = moment(start)
      // const mEnd = moment(end)
      // const duration = moment.duration(mEnd.diff(mStart))
      const reminder = duration.asMinutes() % 30
      if (reminder < 10) {
        duration.subtract(reminder, 'minutes')
      } else {
        duration.add(30 - reminder, 'minutes')
      }
      return duration.asHours()
    },
    createVismaInvoice (id) {
      let theOrderRows = []
      let theSpecifications = []
      for (const order of this.filterOrders(id)) {
        theOrderRows.push({tag: 'Separator', text: order.id + ', ' + order.data.CustomerPlaces[0].data.name, amount: ''})
        let newSpec = {
          date: this.deliveryPeriod,
          customer: this.customerData,
          header: order.id + ', ' + order.data.CustomerPlaces[0].data.name,
          rows: []
        }
        let newOrderRows = []
        for (const row of order.data.orderRows) {
          const work = this.calculateOrderRowHours(row)
          let rowToUpdate = newOrderRows.find(r => r.article === row.articleId)
          if (rowToUpdate === undefined) {
            let rowToAdd = {
              article: row.articleId,
              text: row.articleName,
              amount: work.duration
            }
            newOrderRows.push(rowToAdd)
          } else {
            rowToUpdate.amount += work.duration
          }
          newSpec.rows.push({
            article: row.articleId,
            text: row.articleName,
            amount: parseFloat(work.duration).toFixed(1) + ' tim',
            driver: this.DRIVERS_BY_ID(row.driverId).userName,
            veichule: row.truckName,
            start: work.rowStart.format('YYMMDD HH:mm'),
            end: work.rowEnd.format('YYMMDD HH:mm')
          })
        }
        theSpecifications.push(newSpec)
        theOrderRows = [...theOrderRows, ...newOrderRows]
      }
      theOrderRows.forEach((r) => {
        r.amount = r.amount === '' ? r.amount : r.amount.toFixed(2)
      })
      this.actualSpecifications = [...theSpecifications]
      return theOrderRows
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Invoices/InvoiceHydroCreate.vue